import React from 'react';
import { motion } from 'framer-motion';
interface ToggleOption {
  id: string;
  label: string;
  description?: string;
}
interface ToggleProps {
  options: [ToggleOption, ToggleOption];
  activeId: string;
  onChange: (id: string) => void;
  className?: string;
  'aria-label'?: string;
}
export function Toggle({
  options,
  activeId,
  onChange,
  className = '',
  'aria-label': ariaLabel = 'Toggle view mode'
}: ToggleProps) {
  const activeIndex = options.findIndex(o => o.id === activeId);
  return <div role="group" aria-label={ariaLabel} className={`relative inline-flex bg-[#1C1F23] rounded-lg p-1 ${className}`} data-id="element-617">
      {/* Sliding indicator */}
      <motion.div className="absolute top-1 bottom-1 rounded-md bg-[#B08D57]" style={{
      width: `calc(50% - 4px)`
    }} animate={{
      x: activeIndex === 0 ? 0 : 'calc(100% + 8px)'
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 35
    }} aria-hidden="true" data-id="element-618" />

      {options.map(option => <button key={option.id} role="radio" aria-checked={activeId === option.id} onClick={() => onChange(option.id)} className={`relative z-10 px-4 py-2 text-sm font-semibold font-body rounded-md transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#B08D57] focus-visible:ring-offset-1 focus-visible:ring-offset-[#1C1F23] ${activeId === option.id ? 'text-[#1C1F23]' : 'text-[#F7F7F5]/70 hover:text-[#F7F7F5]'}`} style={{
      minWidth: '120px'
    }} data-id="element-619">
          {option.label}
        </button>)}
    </div>;
}